import { useSingleBanner } from '@entities/Banners'

import type { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import styles from '@features/main-page-builder/ui/styles.module.scss'

import { BannerCarousel } from '@widgets/banner-carousel'






export default function BannerBlock ({ payload }: BlockProps) {
  const { banner, loading } = useSingleBanner({
    id: payload?.id as string || ''
  })

  if (!payload?.id || banner === null) {
    return null
  }

  return (
    <div className={styles.root__banner}>
      <BannerCarousel
        banners={[ banner ]}
        loading={loading}
        variant='simple'
      />
    </div>
  )
}
